module.exports = __webpack_public_path__ + "static/media/arrow-icon.018fc017.svg";